export default interface IConcessionCardError {
	cardNumberError: string;
	letterError: string;
	expireAtError: string;
}

export const InitialConcessionCardErrorState: IConcessionCardError = {
	cardNumberError: "",
	letterError: "",
	expireAtError: "",
};
